import React from 'react'

const BusinessLoanForm = () => {
    return (
        <form>
            {/* x---------------------------------x Personal Information x---------------------------------x */}
            <div className="row form-section g-3">
                <h4 className="text-dark fs-5 fw-semibold">Personal Information</h4>
                <div className="col-md-6">
                    <label htmlFor="fullName" className="form-label">Full Name</label>
                    <input type="text" className="form-control-lg form-control "
                        id="fullName" placeholder="John Doe" required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="dob" className="form-label">Date of Birth</label>
                    <input type="date" className="form-control-lg form-control" id="dob"
                        required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input type="email" className="form-control-lg form-control"
                        id="email" placeholder="john.doe@example.com" required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="phoneNumber" className="form-label">Phone
                        Number</label>
                    <input type="tel" className="form-control-lg form-control"
                        id="phoneNumber" placeholder="+1 234 567 8900" required />
                </div>
                <div className="col-md-12">
                    <label htmlFor="address" className="form-label">Residential
                        Address</label>
                    <textarea className="form-control-lg form-control" id="address"
                        rows="3" placeholder="123 Main St, Apt 4B, City, State, ZIP"
                        required></textarea>
                </div>
            </div>

            {/* x---------------------------------x Employment Information x---------------------------------x */}
            <div className="row g-3 py-3 form-section">
                <h4 className="text-dark fs-5 fw-semibold">Employment Information</h4>
                <div className="col-md-6">
                    <label htmlFor="employer" className="form-label">Employer</label>
                    <input type="text" className="form-control-lg form-control"
                        id="employer" placeholder="ABC Corp" required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="jobTitle" className="form-label">Job Title</label>
                    <input type="text" className="form-control-lg form-control"
                        id="jobTitle" placeholder="Software Engineer" required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="annualIncome" className="form-label">Annual
                        Income</label>
                    <input type="number" className="form-control-lg form-control"
                        id="annualIncome" placeholder="50000" required />
                </div>
            </div>

            {/* x---------------------------------x Loan Details x---------------------------------x */}
            <div className="row g-3 py-3 form-section">
                <h4 className="text-dark fs-5 fw-semibold">Loan Details</h4>
                <div className="col-sm-12 ">
                    <label htmlFor="loanAmount" className="form-label">Loan Amount
                        Requested</label>
                    <input type="number" className="form-control-lg form-control"
                        id="loanAmount" placeholder="10000" required />
                </div>
                <div className="col-sm-12 ">
                    <label htmlFor="loanPurpose" className="form-label">Purpose of
                        Loan</label>
                    <textarea className="form-control-lg form-control" id="loanPurpose"
                        rows="3"
                        placeholder="Home renovation, debt consolidation, etc."
                        required></textarea>
                </div>
                <div className="col-sm-12 ">
                    <label htmlFor="loanTerm" className="form-label">Loan Term</label>
                    <select className="form-select form-control-lg" id="loanTerm"
                        required defaultValue={'DEFAULT'} >
                        <option value="DEFAULT" disabled>Select term</option>
                        <option value="12">12 months</option>
                        <option value="24">24 months</option>
                        <option value="36">36 months</option>
                        <option value="48">48 months</option>
                        <option value="60">60 months</option>
                    </select>
                </div>
            </div>

            {/* x---------------------------------x Consent and Submit x---------------------------------x */}
            <div className="mb-3 form-check">
                <input type="checkbox" className="form-check-input" id="consent"
                    required />
                <label className="form-check-label" htmlFor="consent">I agree to the
                    terms and conditions.</label>
            </div>

            {/* x---------------------------------x Submit Button x---------------------------------x */}
            <button type="submit" className="btn btn-primary">Submit Application</button>

        </form>
    )
}

export default BusinessLoanForm